import Swiper, {
  Autoplay,
  Controller,
  EffectFade,
  FreeMode,
  Lazy,
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs,
} from "swiper";
import tippy from "tippy.js";
import "tippy.js/dist/svg-arrow.css";
import Common from "./common";
import LazyLoad from "vanilla-lazyload";

export default {
  init() {
    this.events();
    this.hero();
    this.infoSwiper();
    this.quotesSwiper();
    this.timelineSwiper();
    this.accordion();
    this.pageCards();
    this.photoCarouselSwiper();
    this.photoTextCarouselSwiper();
    this.tooltip();
    this.newTimelineSwiper();
    this.playVideo();
    this.externalNews();
    this.logoSwiper();
  },

  events() {
    $(".hero__scroll").on("click", (e) => {
      const contentEl = $(e.currentTarget).closest("section").next();

      Common.scrollTo(contentEl[0], true);
    });

    $(".page-nav__link").on("click", (e) => {
      $(e.currentTarget)
        .addClass("active")
        .parent()
        .siblings()
        .children()
        .removeClass("active");
    });
  },

  hero() {
    const wrapEl = $(".block-hero");

    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".swiper");

    new Swiper(swiperEl[0], {
      watchSlidesProgress: true,
      modules: [Navigation, Pagination, Lazy, EffectFade],
      effect: "fade",
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      lazy: {
        enabled: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: wrapEl.find(".swiper-nav--prev")[0],
        nextEl: wrapEl.find(".swiper-nav--next")[0],
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
      },
    });
  },

  infoSwiper() {
    if (!$(".info-swiper").length) {
      return;
    }

    $(".info-swiper").each((_i, el) => {
      const wrapEl = $(el);
      const swiperEl = wrapEl.children(".swiper");

      const swiper = new Swiper(swiperEl[0], {
        watchSlidesProgress: true,
        modules: [Navigation, Pagination, Lazy],
        lazy: {
          enabled: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: wrapEl.find(".swiper-nav--prev")[0],
          nextEl: wrapEl.find(".swiper-nav--next")[0],
        },
        pagination: {
          el: wrapEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          900: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
      });

      const btnEl = $(".a11y__fs.active");
      this.infoSwiperFix(btnEl, swiper);

      $(".a11y__fs").on("click", (e) => {
        const btnEl = $(e.currentTarget);
        this.infoSwiperFix(btnEl, swiper);
      });
    });
  },

  infoSwiperFix(btnEl, swiper) {
    const fs = btnEl.data("fs");

    if (window.innerWidth < 900) {
      swiper.params.slidesPerView = 1;
    } else {
      if ("default" !== fs && typeof fs !== "undefined") {
        swiper.params.slidesPerView = 1;
        swiper.params.slidesPerGroup = 1;
      } else {
        swiper.params.slidesPerView = 3;
        swiper.params.slidesPerGroup = 3;
      }
    }
  },

  quotesSwiper() {
    if (!$(".quotes-swiper").length) {
      return;
    }

    $(".quotes-swiper").each((_i, el) => {
      const wrapEl = $(el);

      const quotesSwiperEl = wrapEl.find(".quotes-swiper__quote .swiper");

      const quotes = new Swiper(quotesSwiperEl[0], {
        modules: [Navigation, Pagination, Controller],
        controller: true,
        autoHeight: true,
        navigation: {
          prevEl: wrapEl.find(".swiper-nav--prev")[0],
          nextEl: wrapEl.find(".swiper-nav--next")[0],
        },
        pagination: {
          el: wrapEl.find(".swiper-pagination")[0],
          clickable: true,
        },
      });

      const personsSwiperEl = wrapEl.find(".quotes-swiper__person .swiper");
      const persons = new Swiper(personsSwiperEl[0], {
        modules: [Controller],
        controller: true,
      });

      persons.controller.control = quotes;
      quotes.controller.control = persons;
    });
  },

  timelineSwiper() {
    const wrapEl = $(".timeline-wrap");
    if (!wrapEl.length) {
      return;
    }

    // Read more toggle
    $(".timeline-slide-item__more").on("click", (e) => {
      let btnState;
      const btnEl = $(e.currentTarget);

      btnEl
        .toggleClass("open")
        .siblings(".timeline-slide-item__desc--more")
        .slideToggle(200);

      if (btnEl.hasClass("open")) {
        btnState = "less";
      } else {
        btnState = "more";
      }
      btnEl.children("span").text(btnEl.data(btnState));
    });

    // Swipers
    wrapEl.each((_i, el) => {
      const wrapEl = $(el);

      const yearsEl = wrapEl.find(".timeline-years");

      const yearsSwiper = new Swiper(yearsEl[0], {
        allowTouchMove: false,
        watchSlidesProgress: true,
        breakpoints: {
          0: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 3,
          },
          900: {
            slidesPerView: 5,
          },
        },
      });

      const timelineEl = wrapEl.find(".timeline-swiper");

      new Swiper(timelineEl[0], {
        modules: [Thumbs, EffectFade, Navigation],
        thumbs: {
          swiper: yearsSwiper,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          prevEl: wrapEl.find(".swiper-nav--prev")[0],
          nextEl: wrapEl.find(".swiper-nav--next")[0],
        },
      });
    });
  },

  accordion() {
    $(".accordion-item button").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      if (btnEl.hasClass("animating")) {
        return;
      }
      btnEl.addClass("animating");
      const wrapEl = btnEl.closest(".accordion-item");

      wrapEl
        .siblings()
        .removeClass("open")
        .children(".accordion-item__content")
        .slideUp(250);

      if (wrapEl.hasClass("open")) {
        wrapEl
          .removeClass("open")
          .children(".accordion-item__content")
          .slideUp(250);
      } else {
        wrapEl
          .addClass("open")
          .children(".accordion-item__content")
          .slideDown(250);
      }

      setTimeout(() => {
        btnEl.removeClass("animating");
      }, 250);
    });
  },

  pageCards() {
    $(".page-card").each((_i, el) => {
      const cardEl = $(el);

      const contentHeight = cardEl
        .children(".page-card__content")
        .innerHeight();
      const imageHeight = cardEl.children(".page-card__image").innerHeight();

      if (contentHeight < imageHeight) {
        cardEl.addClass("page-card--center");
      }
    });
  },

  photoCarouselSwiper() {
    const wrapEl = $(".photo-carousel");
    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".photo-carousel__swiper");

    new Swiper(swiperEl[0], {
      modules: [Navigation, Pagination, Lazy],
      initialSlide: 1,
      spaceBetween: 50,
      navigation: {
        prevEl: wrapEl.find(".swiper-nav--prev")[0],
        nextEl: wrapEl.find(".swiper-nav--next")[0],
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        900: {
          slidesPerView: 2,
        },
      },
    });
  },

  photoTextCarouselSwiper() {
    const wrapEl = $(".photo-text-carousel");
    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".photo-text-carousel__swiper");

    new Swiper(swiperEl[0], {
      modules: [Navigation, Pagination, Lazy],

      loop: true,
      navigation: {
        prevEl: wrapEl.find(".swiper-nav--prev")[0],
        nextEl: wrapEl.find(".swiper-nav--next")[0],
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
      },
    });
  },

  tooltip() {
    const tooltipBtn = $('button.tooltip');

    if (!tooltipBtn.length) {
      return;
    };

    tooltipBtn.each((index, btn) => {
      let tooltipTitle = '';
      let tooltipDesc = '';

      let tooltipDataString = $(btn).children('#tooltipData').attr('data-tooltip');
      let tooltipData = JSON.parse(tooltipDataString);

      tooltipTitle = tooltipData.title;
      tooltipDesc = tooltipData.desc;

      tippy(btn, {
        content: `
        <p class="tooltip-block__title">${tooltipTitle}</p>
        <p class="tooltip-block__description">${tooltipDesc}</p>`,
        allowHTML: true,
        trigger: "click",
        arrow: `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="close">
        <circle id="Ellipse 5" cx="20" cy="20" r="19.5" transform="rotate(180 20 20)" fill="white" stroke="#1E1E1E"/>
        <g id="Group 21">
        <path id="Line 10" d="M27 27L13 13" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"/>
        <path id="Line 11" d="M13 27L27 13" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"/>
        </g>
        </g>
        </svg>`,
        maxWidth: 405,
        placement: "auto",
      });
    });
  },

  newTimelineSwiper() {
    $(".timeline").each(function () {
      const wrapEl = $(this);
      const swiperEl = wrapEl.find(".swiper");
      const numberOfSlides = swiperEl.find(".swiper-slide").length;

      let slidesPerView = 1;

      if (numberOfSlides >= 5) {
        // If the number of slides is 5 or more, maintain the original behavior
        slidesPerView = 5;
      } else {
        // If the number of slides is less than 5, set slidesPerView according to available space
        slidesPerView = numberOfSlides;
      }

      new Swiper(swiperEl[0], {
        modules: [Navigation],
        slidesPerView: slidesPerView,
        breakpoints: {
          100: {
            slidesPerView: numberOfSlides >= 5 ? 1 : Math.min(1, numberOfSlides)
          },
          700: {
            slidesPerView: numberOfSlides >= 5 ? 2 : Math.min(2, numberOfSlides)
          },
          900: {
            slidesPerView: numberOfSlides >= 5 ? 3 : Math.min(3, numberOfSlides)
          },
          1200: {
            slidesPerView: numberOfSlides >= 5 ? 4 : Math.min(4, numberOfSlides)
          },
          1440: {
            slidesPerView: numberOfSlides >= 5 ? 5 : Math.min(5, numberOfSlides)
          }
        },
        navigation: {
          prevEl: wrapEl.find(".swiper-nav--prev")[0],
          nextEl: wrapEl.find(".swiper-nav--next")[0],
        },
      });
    });
  },

  externalNews() {
    $("[data-block-id]").each(function () {
      var blockId = $(this).data("block-id");
      var newsEl = $(`.external-news[data-block-id="${blockId}"]`);
      var btnEl = $(`.external-news__category-item[data-block-id="${blockId}"]`);

      if (!newsEl.length) {
        return;
      }

      btnEl.on("click", (e) => {
        btnEl.removeClass("active");
        $(e.currentTarget).addClass("active");
        let category = $(e.currentTarget).data("cat");
        $(`.external-news__cat-block[data-block-id="${blockId}"]`).addClass("hidden");
        $(`.external-news__cat-block--${category}[data-block-id="${blockId}"]`).removeClass("hidden");
      });
    });
  },

  playVideo() {
    // play video
    const videoBlocks = document.querySelectorAll(".video-block");

    videoBlocks.forEach((wrapEl) => {
      const playBtn = wrapEl.querySelector(".video-block__play-btn");
      const video = wrapEl.querySelector(".video-block__video");

      if (playBtn) {
        if (video) {
          playBtn.addEventListener("click", () => {
            playBtn.parentNode.classList.toggle("loading");

            LazyLoad.load(video, {
              callback_loaded: () => {
                playBtn.parentNode.classList.toggle("loaded");

                setTimeout(() => {
                  video.play();
                }, 200);
              },
            });
          });
        }
      }
    });
  },
  logoSwiper() {
    const wrapEl = $(".logo-slider");
    if (!wrapEl.length) {
      return;
    }

    const scrollbarEl = wrapEl.find(".swiper-scrollbar")[0];
    const dragEl = wrapEl.find(".swiper-scrollbar-drag")[0];
    const swiperEl = wrapEl.find(".swiper");

    new Swiper(swiperEl[0], {
      modules: [Scrollbar, Autoplay, FreeMode],
      spaceBetween: 12,
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentum: true,
        sticky: false,
      },
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 10000,
      scrollbar: {
        el: scrollbarEl,
        dragEl: dragEl,
        draggable: true,
        dragSize: 14,
        hide: false,
      },
    });
  }
};
